import * as React from "react";
import logo from "../../resources/images/logo.png";
import facebook from "../../resources/images/facebook.png";
import instagram from "../../resources/images/instagram.png";
import twitter from "../../resources/images/twitter.png";
import website from "../../resources/images/website.png";
import youtube from "../../resources/images/youtube.png";
import { Link } from "react-router-dom";
import "./header.css";

export const Header = () => (
  <div className="navigation">
    <div className="container-fluid">
      <div className="row justify-content-between">
        <div className="col-md-2">
          <Link to={{ pathname: "/" }}>
            <img src={logo} className="img-fluid p-3 logo" alt="Logo UFG" />
          </Link>
        </div>
        <div className="col-md-4 d-flex align-items-center justify-content-center">
          <ul className="social-media">
            <li>
              <a
                href="https://es-la.facebook.com/ufgoficial"
                target="_blank"
                rel="noreferrer"
              >
                <img src={facebook} className="" alt="social UFG"></img>
              </a>
            </li>
            <li>
              <a
                href="https://www.instagram.com/nuevo_ingresoufg"
                target="_blank"
                rel="noreferrer"
              >
                <img src={instagram} className="" alt="social UFG"></img>
              </a>
            </li>
            <li>
              <a
                href="https://twitter.com/UFGoficial"
                target="_blank"
                rel="noreferrer"
              >
                <img src={twitter} className="" alt="social UFG"></img>
              </a>
            </li>
            <li>
              <a
                href="https://www.ufg.edu.sv/"
                target="_blank"
                rel="noreferrer"
              >
                <img src={website} className="" alt="social UFG"></img>
              </a>
            </li>
            <li>
              <a
                href="https://www.youtube.com/user/redsocialufg"
                target="_blank"
                rel="noreferrer"
              >
                <img src={youtube} className="" alt="social UFG"></img>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
);
